import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import services from '../services';
import { emailReply } from '../Redux/slice';
import { useDispatch } from 'react-redux';
import ComposeEmail from './composeEmail/ComposeEmail';
import ReplyDropdown from '../common/ReplyDropdown';
import { getLocalStorageItem } from '../utils/Localstorage/localStorageUtils';
import { LabelList } from '../common/LabelList';
import LabelIcon from '@mui/icons-material/Label';
import NoReplyMailModal from '../common/NoReplyMailModal';
import SandboxedEmail from './SandboxedEmail';
const MailInbox = ({
    dataById,
    getemailbyid,
    formattedBody,
    handlegetEmailDetails,
    attachmentPaths,
    threadData,
    setLoading,
    selectedEmailId,
    childTaskData,
    setCurrentTask,
    selectedMail,
    TaskId,
    handleClick,
    selectedEmailID,
}) => {





    const [emailValue, setEmailValue] = React.useState(() => {
        return selectedMail?.labels?.includes('SENT')
            ? selectedMail?.sentTo?.split('"').filter(Boolean)[0] ||
            selectedMail?.Email?.sentTo?.split('"').filter(Boolean) ||
            childTaskData?.Email?.sentTo?.split('"').filter(Boolean) ||
            ''
            : selectedMail?.sentBy?.split('"').filter(Boolean) ||
            selectedMail?.Email?.sentBy?.split('"').filter(Boolean) ||
            childTaskData?.Email?.sentBy?.split('"').filter(Boolean) ||
            '';
    });
    const [submitData, setSubmitData] = useState('')
    React.useEffect(() => {
        setEmailValue(
            selectedMail?.labels?.includes('SENT')
                ? selectedMail?.sentTo?.split('"').filter(Boolean)[0] ||
                selectedMail?.Email?.sentTo?.split('"').filter(Boolean) ||
                childTaskData?.Email?.sentTo?.split('"').filter(Boolean) ||
                ''
                : selectedMail?.sentBy?.split('"').filter(Boolean) ||
                selectedMail?.Email?.sentBy?.split('"').filter(Boolean) ||
                childTaskData?.Email?.sentBy?.split('"').filter(Boolean) ||
                ''
        );
    }, [selectedMail, childTaskData]);
    const [labelAnchorEl, setLabelAnchorEl] = useState(null);
    const [subEmailLabelAnchorEl, setSubEmailLabelAnchorEl] = useState(null);
    const [selectedSubEmailID, setSelectedSubEmailID] = useState(null);
    const [replyLabelAnchorEl, setReplyLabelAnchorEl] = useState(null);
    const [replyLabelname, setReplyLabelname] = useState([]);
    const [replyLabelIds, setReplyLabelIds] = useState([]);


    const [textAreaValue, setTextAreaValue] = useState('');
    const location = useLocation();
    const [replyDropdown, setReplyDropdown] = useState(false);
    const [replyDropdown1, setReplyDropdown1] = useState(false);
    const [replyDropdown2, setReplyDropdown2] = React.useState(false);
    const [replyDropdown3, setReplyDropdown3] = useState(false);
    const [showMoreOptions, setShowMoreOptions] = useState(false);
    const [openModalId, setOpenModalId] = useState(null);
    const isInboxVisible = location.state?.isInboxVisible || false;
    const dropdownRefs = useRef({});
    const moreOptionsRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openModalId) {
                const currentRef = dropdownRefs.current[openModalId];
                if (currentRef && !currentRef.contains(event.target)) {
                    setOpenModalId(null);
                }
            }

            if (showMoreOptions && !event.target.closest('.more-options-container')) {
                setShowMoreOptions(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openModalId, showMoreOptions]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (Object.values(showMoreOptions).some(isOpen => isOpen) && !event.target.closest('.more-options-container')) {
                setShowMoreOptions({});
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showMoreOptions]);

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
    const [assignedUserName, setAssignedUserName] = useState('');
    const [allTemp, setAllTemp] = useState([]);
    const [cc, setCc] = useState("");
    const [bcc, setBcc] = useState("")
    const [thread, setThread] = useState('');
    const [showCc, setShowCc] = useState(false);
    const [showBcc, setShowBcc] = useState(false);
    const [showBccCc, setShowBccCc] = useState(false)
    const [isForward, setIsForward] = useState(false)
    const [isreplyAll, setIsreplyAll] = useState(false)
    const [isvisible, setIsvisible] = useState(false)
    const [composeStatus, setComposeStatus] = useState(false);
    const [templateselect, setTemplateselect] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [taskAssign, setTaskAssign] = useState([]);
    const [allThreadTask, setAllThreadTask] = useState([]);
    const [template, setTemplate] = useState({
        templateData: '',
    });
    const [draftStatus, setDraftStatus] = useState(false);
    const [saveDrafts, setSaveDrafts] = useState()
    const [draftId, setDraftId] = useState(null);
    const [draftSubThreadId, setDraftSubThreadId] = useState(null);

    const [draftMap, setDraftMap] = useState(new Map());
    const [currentDraftContext, setCurrentDraftContext] = useState({
        subthreadId: null,
        draftId: null,
        isNewDraft: false
    });

    const [allDrafts, setAllDrafts] = useState([]);
    const [selectedDraft, setSelectedDraft] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [expandedThreadIndex, setExpandedThreadIndex] = useState(null);
    const [expandreplyVisible, setExpandreplyVisible] = useState(null)
    const [visibleReplyIndexes, setVisibleReplyIndexes] = useState(new Set());
    const [isMainMailExpanded, setIsMainMailExpanded] = useState(false);
    const [labelForDraft, setLabelForDraft] = useState({ label: "", idx: null });
    const [label, setLabel] = useState("")
    const [showisMailVisible, setShowisMailVisible] = useState(false)

    const handleEmailChange = (e) => {
        setEmailValue(e.target.value);
        setShowBccCc(true)
    };
    const handleCcChange = (e) => {
        setCc(e.target.value)
    }
    const handleBccChange = (e) => {
        setBcc(e.target.value)
    }

    const handleTextAreaChange = (event) => {
        setTextAreaValue(event.target.value);
    };

    const handleToggleSearchBox = () => {
        setIsSearchBoxOpen(!isSearchBoxOpen);
    };

    const handlebackbutton = () => {
        navigate('/app');
    };

    const handleDelete = async (mode = 'replyAll', idx = null) => {
        if (idx !== null) {
            setVisibleReplyIndexes(prev => {
                const newSet = new Set(prev);
                newSet.delete(idx);
                return newSet;
            });
        }

        setExpandreplyVisible(idx)
        if (mode === 'replyAll') {
            setReplyDropdown1(false)
            setReplyDropdown2(false)
            setReplyDropdown3(false)
        } else if (mode === 'visible') {
            setReplyDropdown2(!replyDropdown2)
            setReplyDropdown1(false)
            setReplyDropdown3(false)
        }
        else if (mode === '-') {
            setReplyDropdown3(false)
            setReplyDropdown1(false)
            setReplyDropdown2(false)
        }
        setReplyDropdown(false)
        setEmailValue('')
        setCc('')
        setBcc('')

    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            updateTaskMail(selectedMail?.id);
        }
    };
    const [isReply, setIsReply] = useState(false)
    const [draftBody, setDraftBody] = useState([])
    const handlereply = (mode = 'replyAll', idx, item) => {
        setIsReply(true)
        setIsForward(false)
        setExpandreplyVisible(idx)

        setVisibleReplyIndexes(prev => {
            const newSet = new Set(prev);
            newSet.add(idx);
            return newSet;
        });


        if (mode === 'replyAll') {
            setIsreplyAll(true);
            setIsvisible(false);
            setReplyDropdown1(prev => !prev);

        } else if (mode === 'visible') {

            setIsvisible(true);
            setIsreplyAll(false);

            setReplyDropdown2(!replyDropdown2)

        } else if (mode === '-') {
            setReplyDropdown3(!replyDropdown3);

        }
        const userData = getLocalStorageItem("userData") || {};
        const currentUserEmail = userData?.email || "";
        const extractEmails = (str) => {
            if (!str) return [];
            return str.match(/[\w.-]+@[\w.-]+\.[A-Za-z]{2,}/g) || [];
        };

        let setReply;

        if (mode === 'replyAll') {
            setReply = emailValue;
            setEmailValue(emailValue)

        } else
            if (mode === 'visible') {

                setReply = item;
                const extractEmailOnly = (str) => {
                    if (!str) return '';
                    const angleMatch = str.match(/<([^>]+)>/);
                    if (angleMatch && angleMatch[1]) {
                        return angleMatch[1].trim();
                    }

                    const justEmailMatch = str.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/);
                    if (justEmailMatch) {
                        return justEmailMatch[0].trim();
                    }

                    return '';
                };
                const ccList = item.cc ? item.cc.split(',').map(email => extractEmailOnly(email)) : [];
                const bccList = item.bcc ? item.bcc.split(',').map(email => extractEmailOnly(email)) : [];

                const ccBccList = [...ccList, ...bccList];
                const sentToEmail = extractEmailOnly(selectedMail?.sentTo || selectedMail?.Email?.sentTo || childTaskData?.Email?.sentTo);
                const isMatched = ccBccList.includes(sentToEmail);
                let recipientField;

                if (item) {
                    recipientField = item?.labels?.includes('API-Reply') || item?.labels?.includes('API-Forward') || isMatched ? 'receiver' : 'sender'
                } else {
                    recipientField = selectedMail?.labels?.includes('SENT') ? 'sentTo' : 'sentBy';
                }

                const toRecipients = extractEmails(setReply?.sentTo || setReply?.[recipientField])
                    .filter(r => r !== currentUserEmail);
                setEmailValue(toRecipients.join(', '));
            } else if (mode === '-') {

                setReply = lastReplyBody || selectedMail || selectedMail?.Email || childTaskData?.Email

                const extractEmailOnly = (str) => {
                    if (!str) return '';
                    const angleMatch = str.match(/<([^>]+)>/);
                    if (angleMatch && angleMatch[1]) {
                        return angleMatch[1].trim();
                    }

                    const justEmailMatch = str.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/);
                    if (justEmailMatch) {
                        return justEmailMatch[0].trim();
                    }

                    return '';
                };

                const ccList = setReply.cc ? setReply.cc.split(',').map(email => extractEmailOnly(email)) : [];
                const bccList = setReply.bcc ? setReply.bcc.split(',').map(email => extractEmailOnly(email)) : [];
                const ccBccList = [...ccList, ...bccList];

                const sentToEmail = extractEmailOnly(selectedMail?.sentTo || selectedMail?.Email?.sentTo || childTaskData?.Email?.sentTo);
                const isMatched = ccBccList.includes(sentToEmail);
                let recipientField;

                if (lastReplyBody) {
                    recipientField = lastReplyBody?.labels?.includes('API-Reply') || lastReplyBody?.labels?.includes('API-Forward') || isMatched ? 'receiver' : 'sender'

                } else {
                    recipientField = selectedMail?.labels?.includes('SENT') ? 'sentTo' : 'sentBy';
                }
                const toRecipients = extractEmails(setReply?.[recipientField] || setReply?.receiver)
                    .filter(r => r !== currentUserEmail);

                setEmailValue(toRecipients.join(', '));
            } else {

            }

        setIsForward(false);
        setCc("");
        setBcc("");
    };


    const handleForward = (mode = 'replyAll', idx = null, item) => {
        setIsForward(true);
        setIsReply(false)
        setExpandreplyVisible(idx)
        if (idx !== null) {
            setVisibleReplyIndexes(prev => {
                const newSet = new Set(prev);
                newSet.add(idx);
                return newSet;
            });
        }
        setLabel("Forward")
        setEmailValue(null)

        if (mode === 'replyAll') {
            setReplyDropdown1(prev => !prev);
        }
        else if (mode === 'visible') {
            setReplyDropdown2(!replyDropdown2)

        } else if (mode === '-') {
            setReplyDropdown3(!replyDropdown3)

        }
        setReplyDropdown(!replyDropdown)
    }

    const handleUserSelect = async (user) => {
        setSelectedUserId(user?.id);
        setSearchTerm(user?.name);

        try {
            await updateTaskMail(selectedMail?.id);
            setIsSearchBoxOpen(false);
            toast.success('Task assigned successfully!');
        } catch (error) {
            toast.error('Failed to assign task. Please try again.');
            console.error('Error assigning task:', error);
        }
    };

    const getTaskAssign = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/auth/getAllUser?limit=10&email=${searchTerm}`,
            );
            if (response) {
                setTaskAssign(response?.data?.data?.users);
            }
        } catch (error) {
            console.error('Error fetching task mails:', error);
        }
    };

    const getDraftContext = (subthreadId) => {
        if (!subthreadId) {
            return {
                subthreadId: null,
                draftId: null,
                isNewDraft: false
            };
        }

        const existingDraft = draftMap.get(subthreadId);
        if (existingDraft) {
            return {
                subthreadId,
                draftId: existingDraft.draftId,
                isNewDraft: false
            };
        }

        return {
            subthreadId,
            draftId: null,
            isNewDraft: true
        };
    };

    const updateDraftMap = (subthreadId, draftId) => {
        setDraftMap(prev => {
            const newMap = new Map(prev);
            newMap.set(subthreadId, {
                draftId,
                lastUpdated: new Date().toISOString()
            });
            return newMap;
        });
    };

    const clearDraftContext = () => {
        setCurrentDraftContext({
            subthreadId: null,
            draftId: null,
            isNewDraft: false
        });
        setDraftSubThreadId(null);
        setDraftId(null);
    };

    const loadAllDrafts = async () => {
        try {
            const { gmailMessageId } = selectedMail || childTaskData || {};
            if (!gmailMessageId) {
                return;
            }

            const response = await services.draft.GET_BY_GMAILMSGID(gmailMessageId);
            const drafts = response?.data?.data || [];

            setAllDrafts(drafts);

            drafts.forEach(draft => {
                if (draft.subthreadId) {
                    updateDraftMap(draft.subthreadId, draft.id);
                }
            });

        } catch (error) {
            console.error("Error loading all drafts:", error);
        }
    };

    const loadExistingDraft = async (subthreadId) => {
        try {
            if (!subthreadId) return null;

            const existingDraft = draftMap.get(subthreadId);
            if (existingDraft && existingDraft.draftId) {
                return existingDraft.draftId;
            }

            const { gmailMessageId } = selectedMail || childTaskData || {};
            if (gmailMessageId) {
                const response = await services.draft.GET_BY_GMAILMSGID(gmailMessageId);
                const drafts = response?.data?.data || [];


                let matchingDraft = drafts.find(draft => draft.subthreadId === subthreadId);



                if (!matchingDraft && subthreadId === gmailMessageId) {
                    matchingDraft = drafts.find(draft =>
                        draft.gmailMessageId === gmailMessageId &&
                        (!draft.subthreadId || draft.subthreadId === '')
                    );
                }

                if (matchingDraft) {
                    updateDraftMap(subthreadId, matchingDraft.id);
                    return matchingDraft.id;
                }
            }

            return null;
        } catch (error) {
            console.error("Error loading existing draft:", error);
            return null;
        }
    };

    const getDraftForSubthread = (subthreadId) => {

        let matchingDraft = allDrafts.find(draft => draft.subthreadId === subthreadId);



        if (!matchingDraft && subthreadId) {
            const { gmailMessageId } = selectedMail || childTaskData || {};
            if (gmailMessageId && subthreadId === gmailMessageId) {
                matchingDraft = allDrafts.find(draft =>
                    draft.gmailMessageId === gmailMessageId &&
                    (!draft.subthreadId || draft.subthreadId === '')
                );
            }
        }

        return matchingDraft;
    };

    const switchDraftContext = async (newSubthreadId) => {
        if (newSubthreadId === (currentDraftContext && currentDraftContext.subthreadId)) {
            return;
        }

        const existingDraft = getDraftForSubthread(newSubthreadId);

        if (existingDraft) {

            const newDraftContext = {
                subthreadId: newSubthreadId,
                draftId: existingDraft.id,
                isNewDraft: false
            };

            setCurrentDraftContext(newDraftContext);
            setDraftSubThreadId(newSubthreadId);
            setDraftId(existingDraft.id);

            setTextAreaValue(existingDraft.body || "");
            setSelectedDraft(existingDraft);

            updateDraftMap(newSubthreadId, existingDraft.id);

        } else {

            clearDraftContext();

            const newDraftContext = {
                subthreadId: newSubthreadId,
                draftId: null,
                isNewDraft: true
            };

            setCurrentDraftContext(newDraftContext);
            setDraftSubThreadId(newSubthreadId);
            setTextAreaValue("");
            setSelectedDraft(null);
        }

    };
    const [draftData, setDraftData] = useState('')

    const getExistingDraftData = async (draftId) => {
        try {
            if (!draftId) return null;
            const response = await services.draft.GET_BY_ID_DRAFT(draftId);
            return response?.data?.data;
        } catch (error) {
            console.error("Error fetching draft data:", error);
            return null;
        }
    };

    const validateDraftSubthread = async (draftId, expectedSubthreadId) => {
        try {
            const draftData = await getExistingDraftData(draftId);
            if (!draftData) return false;

            const existingSubthreadId = draftData.subthreadId;
            return existingSubthreadId == expectedSubthreadId;
        } catch (error) {
            console.error("Error validating draft subthread:", error);
            return false;
        }
    };

    const getDraftStatus = () => {
        return {
            currentContext: currentDraftContext,
            draftMap: Array.from(draftMap.entries()),
            legacyDraftId: draftId,
            legacyDraftSubThreadId: draftSubThreadId,
            allDrafts: allDrafts,
            selectedDraft: selectedDraft
        };
    };

    const buildDraftFormData = (targetSubthreadId = null) => {
        const formData = new FormData();

        const { gmailMessageId, sentBy, sentTo, Email, subject, gmailUserId, id, subthreadId } =
            selectedMail == null ? childTaskData : selectedMail || getemailbyid || childTaskData?.Email;

        const senderEmail = (
            (sentTo && sentTo.match(/<([^>]+)>/)?.[1]) ||
            Email?.sentTo?.match(/<([^>]+)>/)?.[1] ||
            sentTo ||
            Email?.sentTo
        )?.trim();

        const receiverEmail = (
            (sentBy && sentBy.match(/<([^>]+)>/)?.[1]) ||
            Email?.sentBy?.match(/<([^>]+)>/)?.[1] ||
            sentBy ||
            Email?.sentBy
        )?.trim();



        // Preserving raw HTML from WYSIWYG editor instead of converting to plain text

        const labels = selectedMail?.labels || childTaskData?.Email?.labels || getemailbyid?.labels;
        if (labels?.includes("SENT")) {
            formData.append("sentBy", receiverEmail);
            formData.append("sentTo", senderEmail);
        } else {
            formData.append("sentBy", senderEmail);
            formData.append("sentTo", receiverEmail);
        }
        formData.append("types", JSON.stringify(labelForDraft));
        formData.append("labels", label)
        formData.append("subject", subject);
        formData.append("gmailMessageId", gmailMessageId);
        const cleanHTML = textAreaValue ? textAreaValue.replace(/\r\n|\r|\n/g, '') : '';
        formData.append("body", cleanHTML);
        formData.append("cc", cc || "");
        formData.append("bcc", bcc || "");
        formData.append("gmailUserId", gmailUserId || "");
        formData.append('parentTaskID', TaskId)

        formData.append('subthreadId', subthreadId || "");

        uploadedFiles.forEach((file) => {
            formData.append("attachments", file);
        });



        return formData;
    };

    const saveDraft = async (targetSubthreadId = null) => {
        try {
            const subthreadId = targetSubthreadId || (currentDraftContext && currentDraftContext.subthreadId) || draftSubThreadId;
            const currentMail = selectedMail || childTaskData;
            const { gmailMessageId } = currentMail || {};


            const hasSubTasks = currentMail && currentMail.SubTasks && currentMail.SubTasks.length > 0;

            if (!hasSubTasks && gmailMessageId) {


                const response = await services.draft.GET_BY_GMAILMSGID(gmailMessageId);
                const existingDrafts = response?.data?.data || [];

                const existingDraftForGmail = existingDrafts.find(draft =>
                    draft.gmailMessageId === gmailMessageId
                );

                if (existingDraftForGmail) {


                    setCurrentDraftContext(prev => ({
                        ...prev,
                        subthreadId: gmailMessageId,
                        draftId: existingDraftForGmail.id,
                        isNewDraft: false
                    }));
                    setDraftId(existingDraftForGmail.id);
                    setDraftSubThreadId(gmailMessageId);
                    await updateDraft(gmailMessageId);
                } else {

                    const formData = buildDraftFormData(gmailMessageId);
                    const res = await services.draft.CREATE_DRAFT(formData);

                    const newDraftId = res?.data?.data?.id;

                    updateDraftMap(gmailMessageId, newDraftId);

                    setCurrentDraftContext(prev => ({
                        ...prev,
                        subthreadId: gmailMessageId,
                        draftId: newDraftId,
                        isNewDraft: false
                    }));

                    setDraftId(newDraftId);
                    setDraftSubThreadId(gmailMessageId);
                    setSaveDrafts("Draft saved");
                    setTimeout(() => setSaveDrafts(""), 3000);
                }
                return;
            }

            if (!subthreadId) {
                console.warn("No subthread ID available for draft creation");
                return;
            }




            if (gmailMessageId && (!subthreadId || subthreadId === gmailMessageId)) {
                const response = await services.draft.GET_BY_GMAILMSGID(gmailMessageId);
                const existingDrafts = response?.data?.data || [];


                const existingDraftWithoutSubthread = existingDrafts.find(draft =>
                    draft.gmailMessageId === gmailMessageId &&
                    (!draft.subthreadId || draft.subthreadId === '')
                );

                if (existingDraftWithoutSubthread) {
                } else {

                    if (!hasSubTasks) {
                        console.warn("No SubTasks found - preventing NEW draft creation for same gmailMessageId");
                        setDraftStatus("No subtasks available for new draft creation");
                        setTimeout(() => setDraftStatus(""), 3000);
                        return;
                    }
                }
            }

            const formData = buildDraftFormData(subthreadId);
            const res = await services.draft.CREATE_DRAFT(formData);

            const newDraftId = res?.data?.data?.id;

            updateDraftMap(subthreadId, newDraftId);

            setCurrentDraftContext(prev => ({
                ...prev,
                subthreadId,
                draftId: newDraftId,
                isNewDraft: false
            }));

            setDraftId(newDraftId);
            setDraftSubThreadId(subthreadId);
            setSaveDrafts("Draft saved");
            setTimeout(() => setSaveDrafts(""), 3000);
        } catch (e) {
            console.error("Draft create failed", e);
            setDraftStatus("Failed to save draft");
        }
    };

    const updateDraft = async (targetSubthreadId = null) => {
        try {
            const subthreadId = targetSubthreadId || (currentDraftContext && currentDraftContext.subthreadId) || draftSubThreadId;

            const draftIdToUpdate = (currentDraftContext && currentDraftContext.draftId) || draftId;
            if (!subthreadId || !draftIdToUpdate) {
                console.warn("Missing subthread ID or draft ID for update");
                return;
            }

            const isValidSubthread = await validateDraftSubthread(draftIdToUpdate, subthreadId);
            const formData = buildDraftFormData(subthreadId);
            formData.append("draftId", draftIdToUpdate);

            await services.draft.UPDATE_DRAFT(draftIdToUpdate, formData);
            updateDraftMap(subthreadId, draftIdToUpdate);

            setSaveDrafts("Draft updated");
            setTimeout(() => setSaveDrafts(""), 3000);

        } catch (e) {
            console.error("Draft update failed", e);
            setDraftStatus("Failed to update draft");
        }
    };

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const encodedProps = query.get('props');
        if (encodedProps) {
            const decodedProps = decodeURIComponent(encodedProps);
            const parsedProps = JSON.parse(decodedProps);
            linkData(parsedProps?.linkId);
        }
    }, [location.search]);

    const linkData = async (linkId) => {
        try {
            const response = await services.task.GET_TASK_LINK_DATA(linkId);
            const data = response?.data?.data;
            if (data) {
                setSelectedUserId(data?.task?.userId);
                getUserById(data?.task?.userId);
                getemailbyid(data?.task?.id);
                setCurrentTask(data?.task);
            }
        } catch (error) { }
    };

    const getUserById = async (userId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/getAllUser`);
            if (response?.data?.data?.users) {
                const user = response.data.data.users.find((u) => u.id === userId);
                if (user) {
                    setAssignedUserName(user.name);
                }
            }
        } catch (error) {
            console.error('Error fetching user:', error);
        }
    };

    useEffect(() => {
        if (location.state) {
            getUserById(location.state.selectedMail.userId);
        }
    }, [location.state]);

    const getDraftwithGmailMsgId = async () => {
        try {
            const response = await services.draft.GET_BY_GMAILMSGID(selectedMail?.gmailMessageId)
            const drafts = response?.data?.data || [];

            let replyIndexes = [];
            let forwardIndexes = [];
            let replyAllIndexes = [];

            const draftBodiesByIdxArr = drafts.map(draft => {
                const types = JSON.parse(draft.types || '{}');
                const draftIndex = types.idx || 0;
                return { idx: draftIndex, draft };
            });

            setDraftBody(draftBodiesByIdxArr)
            drafts.forEach((draft) => {
                const types = JSON.parse(draft.types || '{}');
                const draftIndex = types.idx || 0;

                if (draft.labels === "Reply") {
                    replyIndexes.push(draftIndex);
                    handlereply(
                        types.label,
                        draftIndex,
                        draft
                    );

                } else if (draft.labels === "Forward") {
                    forwardIndexes.push(draftIndex);
                    handleForward(
                        types.label,
                        draftIndex,
                        draft,
                    );
                } else if (draft.labels === "ReplyAll") {
                    replyAllIndexes.push(draftIndex);
                    handleReplyAll(
                        draft,
                        types.label,
                        draftIndex
                    );
                }

                if (draft.subthreadId) {
                    const draftContext = {
                        subthreadId: draft.subthreadId,
                        draftId: draft.id,
                        isNewDraft: false
                    };
                    updateDraftMap(draft.subthreadId, draft.id);
                }
            });

            if (replyIndexes.length > 0) {
                setReplyDropdown2(true);
                setExpandreplyVisible(replyIndexes[0]);
                setVisibleReplyIndexes(new Set(replyIndexes));
            }

            if (forwardIndexes.length > 0) {
                setReplyDropdown3(true);
            }

            if (replyAllIndexes.length > 0) {
                setReplyDropdown1(true);
            }

            setDraftStatus(true);

        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        setExpandreplyVisible(null);
    }, [selectedMail])

    useEffect(() => {
        getTaskAssign();
    }, [searchTerm]);

    const [isReplyloading, setIsReplyLoading] = useState(false);
    const createTask = async () => {
        setUploadedFiles([]);
        setIsReplyLoading(true);

        const { gmailMessageId, sentBy, sentTo, Email, subject } =
            selectedMail == null ? childTaskData : selectedMail || getemailbyid || childTaskData?.Email;

        const selecteMailUserId = selectedEmailId ? selectedEmailId : gmailMessageId;

        const senderEmail = (
            (sentTo && sentTo.match(/<([^>]+)>/)?.[1]) ||
            Email?.sentTo?.match(/<([^>]+)>/)?.[1] ||
            sentTo ||
            Email?.sentTo
        )?.trim();

        const receiverEmail = (
            (sentBy && sentBy.match(/<([^>]+)>/)?.[1]) ||
            Email?.sentBy?.match(/<([^>]+)>/)?.[1] ||
            sentBy ||
            Email?.sentBy
        )?.trim();

        if (senderEmail && receiverEmail) {
            // Preserving raw HTML from WYSIWYG editor instead of converting to plain text
            const formData = new FormData();
            const labels = selectedMail?.labels || childTaskData?.Email?.labels || getemailbyid?.labels;

            if (labels?.includes('SENT')) {
                formData.append('sender', receiverEmail);
                formData.append('receiver', isReply == true || isForward == true ? emailValue : senderEmail);
            } else {
                formData.append('sender', senderEmail);
                formData.append('receiver', isReply == true || isForward == true ? emailValue : receiverEmail);
            }
            let text = '';
            if (isForward) {
                text = 'Fwd'
            } else {
                text = 'Re'
            }
            const cleanHTML = textAreaValue ? textAreaValue.replace(/\r\n|\r|\n/g, '') : '';
            formData.append('messageId', gmailMessageId);
            formData.append('body', cleanHTML);
            formData.append('subject', `${text}: ${subject}`);
            formData.append('cc', cc || '');
            formData.append('bcc', bcc || '');
            uploadedFiles.forEach((file) => {
                formData.append('attachments', file);
            });

            if (Array.isArray(replyLabelIds) && replyLabelIds.length > 0) {
                formData.append('labelId', replyLabelIds.join(','));
            }

            try {
                let response;
                if (isForward) {
                    response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/email/forward/${selecteMailUserId}`, formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            }
                        }
                    )
                    toast.success('Email forward successfully')
                } else {
                    response = await axios.post(
                        `${process.env.REACT_APP_BACKEND_URL}/email/reply/${selecteMailUserId}`,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        },
                    );
                    toast.success('Reply send successfully')
                }
                if (response) {
                    setReplyDropdown(false);
                    setReplyDropdown1(false);
                    setReplyDropdown2(false);
                    setReplyDropdown3(false);
                    setVisibleReplyIndexes(new Set());
                    setExpandreplyVisible(null);
                    handlegetEmailDetails(selecteMailUserId);
                    setTextAreaValue('');
                    dispatch(emailReply());
                    setTemplateselect([]);
                    setReplyLabelname([]);
                    setReplyLabelIds([]);

                }

            } catch (error) {
                toast?.error(error?.response?.data?.error);
            } finally {
                setIsReplyLoading(false);
            }
        }
    };

    const updateTaskMail = async (id, deadlineData) => {
        const msgId = selectedMail?.gmailMessageId;
        const data = {
            deadline: deadlineData,
            gmailMessageId: msgId,
            userId: selectedUserId,
        };

        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${id}`, data);
            if (response) {
                getTaskAssign();
            }
        } catch (error) {
            console.error('Error fetching task emails:', error);
        }
    };

    const getTemplate = async () => {
        try {
            const response = await services.template.GET_ALL_TEMPLATE();
            if (response && Array.isArray(response.templates) && response.templates.length > 0) {
                const filteredTemplates = response.templates.filter(item => item.status === true);
                const mappedTemplates = filteredTemplates.map(item => ({
                    label: item.name || '',
                    value: item.body || '',
                    displayValue: (item.body || '').replace(/\n/g, ' ')
                }));
                setAllTemp(mappedTemplates);
            } else {
                setAllTemp([]);
            }
        } catch (e) {
            console.error(e);
        }
    };
    useEffect(() => {
        getTemplate();
    }, []);

    useEffect(() => {
        if (selectedMail && location?.state?.clickMailTask) {
            let Arr = [];

            Arr.push(selectedMail);

            if (selectedMail.SubTasks && selectedMail.SubTasks.length > 0) {
                Arr.push(...selectedMail?.SubTasks);
            }
            setThread(Arr?.length > 0 && Arr[0]?.id);
            setAllThreadTask(Arr);
            setExpandedThreadIndex(null);
        }
    }, [selectedMail]);

    const handleRemoveFile = (index) => {
        setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const [showAllReplies, setShowAllReplies] = useState(false);

    const visibleReplies = showAllReplies ? formattedBody : formattedBody?.slice(-2);

    const hiddenRepliesCount = formattedBody?.length - 2;

    function formatEmailBody(body) {
        if (!body) return '';
        return body.replace(/(?:\r\n|\r|\n)/g, '<br/>');
    }

    function renderThread(threadArr, level = 0) {
        if (!threadArr || threadArr.length === 0) return null;
        return threadArr.map((item, idx) => (
            <div
                key={item.id || idx}
                style={{
                    marginLeft: level * 24,
                    borderLeft: level ? '2px solid #eee' : 'none',
                    paddingLeft: 12,
                    marginTop: 8,
                    marginBottom: 8,
                }}
            >
                <div className="text-xs text-gray-500 mb-1">
                    {item.sender} &lt;{item.receiver}&gt; — {moment(item.createdAt).format('MMM D, YYYY, h:mm A')}
                </div>
                <SandboxedEmail
                    className="text-[15px] text-gray-700 mb-2 pl-0"
                    html={item.body ? (!/<[a-z][\s\S]*>/i.test(item.body) ? item.body.replace(/\r\n|\r|\n/g, '<br/>') : item.body) : ''}
                />
            </div>
        ));
    }

    const formatMailBodyNonDestructive = (body) => {
        if (!body) return '';
        // If the body does not contain any typical HTML tags, treat it as plain text and replace \n with <br/>
        if (!/<[a-z][\s\S]*>/i.test(body)) {
            return body.replace(/(\r\n|\r|\n)/g, '<br/>');
        }
        return body;
    };

    const processMailBody = (body) => {
        if (!body) return { main: '', rest: '', count: 0 };

        const pattern = /On [\s\S]*?wrote:/gi;
        const matches = body.match(pattern);
        const count = matches ? matches.length : 0;

        const formatMain = (text) => {
            if (!text) return '';
            if (!/<[a-z][\s\S]*>/i.test(text)) {
                return text.replace(/(\r\n|\r|\n)/g, '<br/>');
            }
            return text;
        };

        if (count === 0) {
            return { main: formatMain(body), rest: '', count };
        }

        const firstMatchIndex = body.search(pattern);
        const mainPart = body.slice(0, firstMatchIndex).trim();
        const restPart = body.slice(firstMatchIndex).trim();

        return {
            main: formatMain(mainPart),
            rest: formatMain(restPart),
            count,
        };
    };

    const MAX_IMAGES = 3;

    const handleFileChange = (e) => {
        if (e.target.files) {
            const newFiles = Array.from(e.target.files);
            if (uploadedFiles.length + newFiles.length > MAX_IMAGES) {
                toast.error(`You can only select up to ${MAX_IMAGES} images.`);
                return;
            }
            setUploadedFiles((prev) => [...prev, ...newFiles]);
        }
    };

    const lastReplyBody = visibleReplies?.length > 0
        ? visibleReplies[visibleReplies?.length - 1]
        : "";

    const handleReplyAll = (item = null, mode = 'replyAll', idx = null) => {
        setExpandreplyVisible(idx)
        setIsReply(false);
        setIsForward(false)
        setLabel("ReplyAll")

        if (idx !== null) {
            setVisibleReplyIndexes(prev => {
                const newSet = new Set(prev);
                newSet.add(idx);
                return newSet;
            });
        }

        if (mode === 'replyAll') {
            setIsreplyAll(true);
            setIsvisible(false);
            setReplyDropdown1(prev => !prev);
        } else if (mode === 'visible') {
            const subthreadId = item?.subThreadId || item?.subthreadId || item?.gmailMessageId;
            switchDraftContext(subthreadId);
            setIsvisible(true);
            setIsreplyAll(false);
            setReplyDropdown2(!replyDropdown2)

        } else if (mode === '-') {
            setReplyDropdown3(!replyDropdown3)

        }
        const userData = getLocalStorageItem("userData") || {};
        const currentUserEmail = userData?.email || "";
        const extractEmails = (str) => {
            if (!str) return [];
            return str.match(/[\w.-]+@[\w.-]+\.[A-Za-z]{2,}/g) || [];
        };

        let setReply;

        if (mode === 'replyAll') {
            setReply = emailValue;
            setEmailValue(emailValue)
        } else if (mode === 'visible') {
            setReply = item;
            const extractEmailOnly = (str) => {
                if (!str) return '';
                const angleMatch = str.match(/<([^>]+)>/);
                if (angleMatch && angleMatch[1]) {
                    return angleMatch[1].trim();
                }

                const justEmailMatch = str.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/);
                if (justEmailMatch) {
                    return justEmailMatch[0].trim();
                }

                return '';
            };

            const ccList = item.cc ? item.cc.split(',').map(email => extractEmailOnly(email)) : [];
            const bccList = item.bcc ? item.bcc.split(',').map(email => extractEmailOnly(email)) : [];
            const ccBccList = [...ccList, ...bccList];

            const sentToEmail = extractEmailOnly(selectedMail?.sentTo || selectedMail?.Email?.sentTo || childTaskData?.Email?.sentTo);
            const isMatched = ccBccList.includes(sentToEmail);

            let recipientField;

            if (item) {
                recipientField = item?.labels?.includes('API-Reply') || item?.labels?.includes('API-Forward') || isMatched ? 'receiver' : 'sender'
            } else {
                recipientField = selectedMail?.labels?.includes('SENT') ? 'sentTo' : 'sentBy';
            }

            const toRecipients = extractEmails(setReply?.sentTo || setReply?.[recipientField])
                .filter(r => r !== currentUserEmail);
            setEmailValue(toRecipients.join(', '));
        } else if (mode === '-') {
            setReply = lastReplyBody || selectedMail || selectedMail?.Email || childTaskData?.Email;
            const extractEmailOnly = (str) => {
                if (!str) return '';
                const angleMatch = str.match(/<([^>]+)>/);
                if (angleMatch && angleMatch[1]) {
                    return angleMatch[1].trim();
                }

                const justEmailMatch = str.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/);
                if (justEmailMatch) {
                    return justEmailMatch[0].trim();
                }

                return '';
            };

            const ccList = setReply.cc ? setReply.cc.split(',').map(email => extractEmailOnly(email)) : [];
            const bccList = setReply.bcc ? setReply.bcc.split(',').map(email => extractEmailOnly(email)) : [];
            const ccBccList = [...ccList, ...bccList];

            const sentToEmail = extractEmailOnly(selectedMail?.sentTo || selectedMail?.Email?.sentTo || childTaskData?.Email?.sentTo);
            const isMatched = ccBccList.includes(sentToEmail);
            let recipientField;

            if (lastReplyBody) {
                recipientField = lastReplyBody?.labels?.includes('API-Reply') || lastReplyBody?.labels?.includes('API-Forward') || isMatched ? 'receiver' : 'sender'

            } else {
                recipientField = selectedMail?.labels?.includes('SENT') ? 'sentTo' : 'sentBy';
            }

            const toRecipients = extractEmails(setReply?.[recipientField] || setReply?.receiver)
                .filter(r => r !== currentUserEmail);

            setEmailValue(toRecipients.join(', '));
        } else {
            setReply = selectedMail || selectedMail?.Email || childTaskData?.Email;
        }
        const ccRecipients = extractEmails(setReply?.cc)
            .filter(r => r !== currentUserEmail);

        setCc(ccRecipients.join(', '));
        setShowCc(!!ccRecipients.length);

    };

    React.useEffect(() => {
        if (!replyDropdown) {
            setShowCc(false);
            setShowBcc(false);
            setShowBccCc(false);
        }
    }, [replyDropdown]);

    const hasSubEmailCcBcc = (selectedMail?.SubEmails || getemailbyid?.SubEmails || childTaskData?.Email?.SubEmails || []).some(
        (sub) => (sub.cc && sub.cc.trim() !== "") || (sub.bcc && sub.bcc.trim() !== "")
    );
    const visibleRepliesHasMultipleReceivers = visibleReplies?.some(reply => {
        if (typeof reply.receiver === 'string') {
            const receiversArray = reply.receiver.split(',').map(email => email.trim());
            return receiversArray.length > 1;
        }
        return false;
    });
    const sentToString = selectedMail?.sentTo || selectedMail?.Email?.sentTo || childTaskData?.Email?.sentTo;

    const multipleSentTo = typeof sentToString === 'string'
        ? sentToString.split(',').map(s => s.trim()).length > 1
        : false;
    const shouldShowReplyAll =
        hasSubEmailCcBcc ||
        visibleRepliesHasMultipleReceivers ||
        multipleSentTo ||
        !!selectedMail?.cc ||
        !!getemailbyid?.cc ||
        !!childTaskData?.Email?.cc ||
        !!selectedMail?.bcc ||
        !!getemailbyid?.bcc ||
        !!childTaskData?.Email?.bcc;

    const getDisplayLabels = (labelList) => {
        if (!labelList) return [];

        if (typeof labelList === "string") {
            labelList = labelList
                .split(",")
                .map(l => l.trim());
        }

        if (!Array.isArray(labelList)) return [];

        if (labelList.some(l => l.toUpperCase() === "INBOX")) {
            return ["Inbox"];
        }

        if (labelList.includes("API-Reply")) {
            return ["Sent"];
        }

        return labelList.map(label => toCamelCaseLabel(label));
    };

    const toCamelCaseLabel = (str = "") => {
        return str
            .toLowerCase()
            .split(/_|-/g)
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };
    return (



        <>
            <LabelList
                anchorEl={labelAnchorEl}
                setAnchorEl={setLabelAnchorEl}
                selectedEmailID={selectedEmailID}
                TaskId={TaskId}
            />

            <LabelList
                anchorEl={subEmailLabelAnchorEl}
                setAnchorEl={(val) => {
                    setSubEmailLabelAnchorEl(val);
                    if (!val) setSelectedSubEmailID(null);
                }}
                selectedSubEmailID={selectedSubEmailID}
                TaskId={TaskId}
            />

            <LabelList
                anchorEl={replyLabelAnchorEl}
                setAnchorEl={setReplyLabelAnchorEl}
                labelname={replyLabelname}
                setLabelname={setReplyLabelname}
                setLabelIds={setReplyLabelIds}
                isAdd={true}
            />




            <div
                className="flex flex-col md:flex-row  overflow-hidden"
                style={{
                    boxShadow: ' rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;',
                }}
            >
                <div className="w-full overflow-x-hidden overflow-y-scroll max-h-[100vh]">
                    <div className="bg-white rounded-md shadow-md p-2 md:p-4 ">
                        <div className="flex items-center gap-2 md:!gap-[1.5vw] px-2 py-1  bg-white"></div>
                        <div className="relative">
                            <div className="grid grid-cols-1 gap-x-[15px]">
                                <div className="relative bg-[#fff]">
                                    <div style={{ display: 'flex', justifyContent: 'end' }}>
                                        {composeStatus && (
                                            <ComposeEmail
                                                replyDropdown={composeStatus}
                                                subject={dataById?.subject}
                                                selectedMail={location?.state?.selectedMail}
                                                setComposeStatus={setComposeStatus}
                                                setLoading={setLoading}
                                                attachmentPaths={attachmentPaths}
                                            />
                                        )}
                                    </div>

                                    {selectedMail?.Email || childTaskData?.Email || getemailbyid ? (
                                        <>
                                            {' '}
                                            <div className="">
                                                <div className="mail-inBox-header mail-reading-header">
                                                    <div className="mail-reading-subject-row">
                                                        <h1 className="mail-reading-subject">
                                                            {getemailbyid?.subject || childTaskData?.Email?.subject}
                                                        </h1>
                                                        {getDisplayLabels(
                                                            getemailbyid?.labels ||
                                                            childTaskData?.Email?.labels ||
                                                            []
                                                        ).length > 0 && (
                                                            <span className="mail-reading-label-badge">
                                                                {getDisplayLabels(
                                                                    getemailbyid?.labels ||
                                                                    childTaskData?.Email?.labels ||
                                                                    []
                                                                ).join(', ')}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="conversation-box mail-reading-conversation relative bg-white">
                                                    <div className="mail-reading-message">
                                                        <div className="mail-reading-message-header">
                                                            <div className="mail-reading-message-header-left">
                                                                <div className="mail-reading-avatar">
                                                                    {selectedMail?.name?.trim()?.charAt(0)?.toUpperCase() ||
                                                                        selectedMail?.sender?.trim()?.charAt(0)?.toUpperCase() ||
                                                                        selectedMail?.from?.trim()?.charAt(0)?.toUpperCase() ||
                                                                        getemailbyid?.name?.trim()?.charAt(0)?.toUpperCase() ||
                                                                        childTaskData?.Email?.name?.trim()?.charAt(0)?.toUpperCase()}
                                                                </div>




                                                                <div className="mail-reading-meta">

                                                                    <span className="mail-reading-sender">
                                                                        {selectedMail?.sentBy ||
                                                                            getemailbyid?.sentBy ||
                                                                            childTaskData?.Email?.sentBy}
                                                                    </span>
                                                                    <span className="mail-reading-recipients">
                                                                        {selectedMail?.sentTo || getemailbyid?.sentTo || childTaskData?.Email?.sentTo ? (
                                                                            <>
                                                                                <span className="mail-reading-recipients-label">To</span>
                                                                                {selectedMail?.sentTo || getemailbyid?.sentTo || childTaskData?.Email?.sentTo}
                                                                            </>
                                                                        ) : null}



                                                                        {selectedMail?.cc || getemailbyid?.cc || childTaskData?.Email?.cc ? (
                                                                            <>
                                                                                , cc: {selectedMail?.cc || getemailbyid?.cc || childTaskData?.Email?.cc}
                                                                            </>
                                                                        ) : null}

                                                                        {selectedMail?.bcc || getemailbyid?.bcc || childTaskData?.Email?.bcc ? (
                                                                            <>
                                                                                , bcc: {selectedMail?.bcc || getemailbyid?.bcc || childTaskData?.Email?.bcc}
                                                                            </>
                                                                        ) : null}



                                                                    </span>

                                                                </div>
                                                            </div>
                                                            <div className="mail-reading-toolbar">
                                                                <span className="mail-reading-timestamp">
                                                                {moment(
                                                                    selectedMail?.createdAtEmail ||
                                                                    getemailbyid?.createdAtEmail ||
                                                                    childTaskData?.Email?.createdAtEmail,
                                                                ).format('MMM D, YYYY, h:mm A')}
                                                                </span>

                                                                <span
                                                                    className="mail-reading-action-btn"
                                                                    title="Reply"
                                                                    onClick={() => {
                                                                        if (isInboxVisible && !selectedMail?.boardId) {
                                                                            setShowisMailVisible(true);
                                                                        } else {
                                                                            handlereply('replyAll', null, selectedMail)
                                                                        }
                                                                    }}
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="18"
                                                                        height="18"
                                                                        fill="none"
                                                                        stroke="#444"
                                                                        strokeWidth="1.5"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            d="M10 19l-7-7 7-7"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M3 12h13a6 6 0 0 1 6 6v1"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                                <span
                                                                    ref={moreOptionsRef}
                                                                    className="mail-reading-action-btn relative more-options-container"
                                                                    title="More options"
                                                                    onClick={() => setShowMoreOptions(!showMoreOptions)}
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#444" strokeWidth="1.5" viewBox="0 0 24 24">
                                                                        <circle cx="12" cy="5" r="1.5" />
                                                                        <circle cx="12" cy="12" r="1.5" />
                                                                        <circle cx="12" cy="19" r="1.5" />
                                                                    </svg>

                                                                    {showMoreOptions && (
                                                                        <div className="mail-reading-more-menu">
                                                                            <div>
                                                                                {/* Reply */}
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        if (isInboxVisible && !selectedMail?.boardId) {
                                                                                            setShowisMailVisible(true);
                                                                                            setShowMoreOptions(false);
                                                                                        } else {
                                                                                            handlereply("replyAll", null, selectedMail);
                                                                                            setShowMoreOptions(false);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" className="mr-3">
                                                                                        <path d="M10 19l-7-7 7-7M3 12h13a6 6 0 0 1 6 6v1" strokeLinecap="round" strokeLinejoin="round" />
                                                                                    </svg>
                                                                                    Reply
                                                                                </button>

                                                                                {/* Reply All */}
                                                                                {shouldShowReplyAll && (
                                                                                    <button
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            if (isInboxVisible && !selectedMail?.boardId) {
                                                                                                setShowisMailVisible(true);
                                                                                                setShowMoreOptions(false);
                                                                                            } else {
                                                                                                setIsreplyAll(true);
                                                                                                handleReplyAll(selectedMail, "replyAll", null);
                                                                                                setShowMoreOptions(false);
                                                                                            }

                                                                                        }}
                                                                                    >
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" className="mr-3">
                                                                                            <path d="M7 19l-7-7 7-7M3 12h13a6 6 0 0 1 6 6v1M13 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
                                                                                        </svg>
                                                                                        Reply all
                                                                                    </button>
                                                                                )}

                                                                                {/* Forward */}
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        if (isInboxVisible && !selectedMail?.boardId) {
                                                                                            setShowisMailVisible(true);
                                                                                            setShowMoreOptions(false);
                                                                                        } else {
                                                                                            handleForward("replyAll", null, selectedMail);
                                                                                            setShowMoreOptions(false);
                                                                                        }

                                                                                    }}
                                                                                >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" className="mr-3">
                                                                                        <path d="M14 5l7 7-7 7M21 12H8a6 6 0 0 0-6 6v1" strokeLinecap="round" strokeLinejoin="round" />
                                                                                    </svg>
                                                                                    Forward
                                                                                </button>

                                                                                {/* Label as */}
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setLabelAnchorEl(moreOptionsRef.current);
                                                                                        setShowMoreOptions(false);
                                                                                    }}
                                                                                >
                                                                                    <LabelIcon fontSize="small" sx={{ marginRight: 1 }} />

                                                                                    Label
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                </span>

                                                            </div>
                                                        </div>

                                                        {(() => {
                                                            const mainMailContent = selectedMail?.Email?.body || getemailbyid?.body || childTaskData?.Email?.body || '';
                                                            const { main, rest, count } = processMailBody(mainMailContent);
                                                            return (
                                                                <div className="mail-reading-body-wrap">
                                                                    <SandboxedEmail
                                                                        className="mail-reading-body"
                                                                        html={main}
                                                                    />
                                                                    {count >= 1 && !isMainMailExpanded && (
                                                                        <button
                                                                            type="button"
                                                                            className="mail-reading-expand-btn"
                                                                            onClick={() => setIsMainMailExpanded(true)}
                                                                        >
                                                                            <span>...</span>
                                                                        </button>
                                                                    )}
                                                                    {isMainMailExpanded && count >= 1 && (
                                                                        <>
                                                                            <SandboxedEmail
                                                                                className="mail-reading-body gmail-thread"
                                                                                html={rest}
                                                                            />
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => setIsMainMailExpanded(false)}
                                                                                className="mail-reading-collapse-btn"
                                                                            >
                                                                                Show less
                                                                            </button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            );
                                                        })()}

                                                        {!replyDropdown1 && !isReplyloading && !isreplyAll ?
                                                            null : (
                                                                <ReplyDropdown
                                                                    draftBody={draftBody}
                                                                    emailValue={emailValue}
                                                                    cc={cc}
                                                                    bcc={bcc}
                                                                    showCc={showCc}
                                                                    showBcc={showBcc}
                                                                    setEmailValue={setEmailValue}
                                                                    setCc={setCc}
                                                                    setBcc={setBcc}
                                                                    setShowCc={setShowCc}
                                                                    setShowBcc={setShowBcc}
                                                                    handleEmailChange={handleEmailChange}
                                                                    handleCcChange={handleCcChange}
                                                                    handleBccChange={handleBccChange}
                                                                    replyDropdown={replyDropdown1}
                                                                    setReplyDropdown={setReplyDropdown1}
                                                                    isForward={isForward}
                                                                    isReply={isReply}
                                                                    templateselect={templateselect}
                                                                    setTemplateselect={setTemplateselect}
                                                                    allTemp={allTemp}
                                                                    template={template}
                                                                    setTemplate={setTemplate}
                                                                    textAreaValue={textAreaValue}
                                                                    setTextAreaValue={setTextAreaValue}
                                                                    visibleReplies={visibleReplies}
                                                                    selectedMail={selectedMail}
                                                                    isReplyloading={isReplyloading}
                                                                    createTask={createTask}
                                                                    handleFileChange={handleFileChange}
                                                                    uploadedFiles={uploadedFiles}
                                                                    handleRemoveFile={handleRemoveFile}
                                                                    handleDelete={() => handleDelete('replyAll')}
                                                                    setShowBccCc={setShowBccCc}
                                                                    getemailbyid={getemailbyid}
                                                                    childTaskData={childTaskData}
                                                                    mode='replyAll'
                                                                    saveDrafts={saveDrafts}
                                                                    submitData={submitData}
                                                                    setSubmitData={setSubmitData}
                                                                    labelname={replyLabelname}
                                                                    setLabelAnchorEl={setReplyLabelAnchorEl}
                                                                />

                                                            )}
                                                    </div>

                                                    <div className="py-0">
                                                        <div className="max-w-screen-sm leading-8 text-black bg-[transparent]">
                                                            {attachmentPaths.attachmentPaths &&
                                                                attachmentPaths.attachmentPaths.length > 0 && (
                                                                    <div
                                                                        className="gmail-attachment-list"
                                                                        style={{ padding: '0 4.25rem' }}
                                                                    >
                                                                        {attachmentPaths.attachmentPaths.map(
                                                                            (file, attIdx) => {
                                                                                const fileUrl = `${process.env.REACT_APP_IMAGE_URL || ''
                                                                                    }/${file}`;
                                                                                return (
                                                                                    <div
                                                                                        className="gmail-attachment-card"
                                                                                        key={attIdx}
                                                                                    >
                                                                                        {/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
                                                                                            file,
                                                                                        ) ? (
                                                                                            <a
                                                                                                href={fileUrl}
                                                                                                target="_blank"
                                                                                                rel="noopener noreferrer"
                                                                                            >
                                                                                                <img
                                                                                                    src={fileUrl}
                                                                                                    alt={file}
                                                                                                    style={{
                                                                                                        width: 120,
                                                                                                        height: 120,
                                                                                                        objectFit: 'cover',
                                                                                                        borderRadius: 8,
                                                                                                        border: '1px solid #eee',
                                                                                                    }}
                                                                                                />
                                                                                            </a>
                                                                                        ) : (

                                                                                            <div>
                                                                                                <div className="gmail-attachment-filename-url">
                                                                                                    {(() => {
                                                                                                        const ext = file
                                                                                                            .split('.')
                                                                                                            .pop();
                                                                                                        const name =
                                                                                                            file.slice(
                                                                                                                0,
                                                                                                                -(
                                                                                                                    ext.length +
                                                                                                                    1
                                                                                                                ),
                                                                                                            );
                                                                                                        return name.length >
                                                                                                            10
                                                                                                            ? `${name.slice(
                                                                                                                0,
                                                                                                                10,
                                                                                                            )}... .${ext}`
                                                                                                            : file;
                                                                                                    })()}
                                                                                                </div>
                                                                                                <div>
                                                                                                    <div className="gmail-attachment-pdficon gap-2">
                                                                                                        <div>
                                                                                                            <svg
                                                                                                                width="32"
                                                                                                                height="32"
                                                                                                                viewBox="0 0 24 24"
                                                                                                                fill="none"
                                                                                                            >
                                                                                                                <rect
                                                                                                                    width="24"
                                                                                                                    height="24"
                                                                                                                    rx="4"
                                                                                                                    fill="#F44336"
                                                                                                                />
                                                                                                                <text
                                                                                                                    x="6"
                                                                                                                    y="17"
                                                                                                                    fill="#fff"
                                                                                                                    fontSize="10"
                                                                                                                    fontWeight="bold"
                                                                                                                >
                                                                                                                    {file
                                                                                                                        .split(
                                                                                                                            '.',
                                                                                                                        )
                                                                                                                        .pop()
                                                                                                                        .toUpperCase()}
                                                                                                                </text>
                                                                                                            </svg>
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <span className="gmail-attachment-filename">
                                                                                                                {' '}
                                                                                                                {(() => {
                                                                                                                    const ext =
                                                                                                                        file
                                                                                                                            .split(
                                                                                                                                '.',
                                                                                                                            )
                                                                                                                            .pop();
                                                                                                                    const name =
                                                                                                                        file.slice(
                                                                                                                            0,
                                                                                                                            -(
                                                                                                                                ext.length +
                                                                                                                                1
                                                                                                                            ),
                                                                                                                        );
                                                                                                                    return name.length >
                                                                                                                        10
                                                                                                                        ? `${name.slice(
                                                                                                                            0,
                                                                                                                            10,
                                                                                                                        )}... .${ext}`
                                                                                                                        : file;
                                                                                                                })()}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div className="gmail-attachment-actions">
                                                                                                            <a
                                                                                                                href={
                                                                                                                    fileUrl
                                                                                                                }
                                                                                                                download={
                                                                                                                    file
                                                                                                                }
                                                                                                                target="_blank"
                                                                                                                rel="noopener noreferrer"
                                                                                                                className="gmail-attachment-action-btn"
                                                                                                                title="Download"
                                                                                                            >
                                                                                                                <svg
                                                                                                                    width="20"
                                                                                                                    height="20"
                                                                                                                    fill="#555"
                                                                                                                    viewBox="0 0 16 16"
                                                                                                                >
                                                                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5V13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.6a.5.5 0 0 1 1 0V13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.6a.5.5 0 0 1 .5-.5z" />
                                                                                                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                                                                                </svg>
                                                                                                            </a>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            },
                                                                        )}
                                                                    </div>
                                                                )}

                                                            {formattedBody?.length > 2 && (
                                                                <div
                                                                    onClick={() => setShowAllReplies(!showAllReplies)}
                                                                    className="relative   cursor-pointer"
                                                                >

                                                                    <div className="z-10 absolute bg-white border top-[-0.9vw] left-[0.5vw] border-gray-300 rounded-full w-8 h-8 flex items-center justify-center shadow-sm group-hover:bg-gray-100 transition duration-200">

                                                                        {!showAllReplies && (
                                                                            <span className="text-sm text-gray-700 font-medium group-hover:opacity-0 transition-opacity duration-200">
                                                                                {formattedBody.length - 2}
                                                                            </span>
                                                                        )}
                                                                        <hr />

                                                                        <div className="absolute opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                                                            {!showAllReplies ? (
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="14"
                                                                                    height="14"
                                                                                    fill="gray"
                                                                                    viewBox="0 0 16 16"
                                                                                >
                                                                                    <path d="M8 1.5a.5.5 0 0 1 .374.832l-3.5 4a.5.5 0 0 1-.748-.664l3.5-4A.5.5 0 0 1 8 1.5zm0 13a.5.5 0 0 1-.374-.832l3.5-4a.5.5 0 0 1 .748.664l-3.5 4A.5.5 0 0 1 8 14.5z" />
                                                                                </svg>
                                                                            ) : (
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="14"
                                                                                    height="14"
                                                                                    fill="gray"
                                                                                    viewBox="0 0 16 16"
                                                                                >
                                                                                    <path d="M1.5 10.5a.5.5 0 0 0 .832.374l4-3.5a.5.5 0 0 0-.664-.748l-4 3.5A.5.5 0 0 0 1.5 10.5zM14.5 10.5a.5.5 0 0 1-.832.374l-4-3.5a.5.5 0 0 1 .664-.748l4 3.5a.5.5 0 0 1 .168.374z" />
                                                                                </svg>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {visibleReplies &&
                                                                visibleReplies.length > 0 &&
                                                                visibleReplies.map((item, idx) => {
                                                                    const { main, rest, count } = processMailBody(
                                                                        item.body,
                                                                    );

                                                                    return (
                                                                        <div key={idx} className="mail-reading-thread-item">

                                                                            <hr className="mail-reading-divider" />
                                                                            <div className="mail-reading-message">
                                                                                <div className="mail-reading-message-header">
                                                                                    <div className="mail-reading-message-header-left">
                                                                                        <div className="mail-reading-avatar">
                                                                                            {item?.sender
                                                                                                ? item.sender.trim().charAt(0) === '"'
                                                                                                    ? item.sender.trim().charAt(1)?.toUpperCase()
                                                                                                    : item.sender.trim().charAt(0)?.toUpperCase()
                                                                                                : ""}
                                                                                        </div>


                                                                                        <div className="mail-reading-meta">
                                                                                            <span className="mail-reading-sender">
                                                                                                {item?.sender}


                                                                                                {selectedMail?.bcc || getemailbyid?.bcc || childTaskData?.Email?.bcc ? (
                                                                                                    <>
                                                                                                        , bcc: {selectedMail?.bcc || getemailbyid?.bcc || childTaskData?.Email?.bcc}
                                                                                                    </>
                                                                                                ) : null}
                                                                                            </span>
                                                                                            <span className="mail-reading-recipients">
                                                                                                <span className="mail-reading-recipients-label">
                                                                                                    To
                                                                                                </span>
                                                                                                {item?.receiver}
                                                                                                {item?.cc ? (
                                                                                                    <>
                                                                                                        , cc: {item?.cc}
                                                                                                    </>
                                                                                                ) : null}
                                                                                                {item?.bcc ? (
                                                                                                    <>
                                                                                                        , bcc: {item?.bcc}
                                                                                                    </>
                                                                                                ) : null}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="mail-reading-toolbar">
                                                                                        <span className="mail-reading-timestamp">
                                                                                        {moment(item?.fetchedAtSubEmail)?.format(
                                                                                            'MMM D, YYYY, h:mm A',
                                                                                        )}
                                                                                        </span>
                                                                                        <span
                                                                                            className="mail-reading-action-btn"
                                                                                            title="Reply"
                                                                                            onClick={() => { handlereply('visible', idx, item) }}
                                                                                        >
                                                                                            <svg
                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                width="18"
                                                                                                height="18"
                                                                                                fill="none"
                                                                                                stroke="#444"
                                                                                                strokeWidth="1.5"
                                                                                                viewBox="0 0 24 24"
                                                                                            >
                                                                                                <path
                                                                                                    d="M10 19l-7-7 7-7"
                                                                                                    strokeLinecap="round"
                                                                                                    strokeLinejoin="round"
                                                                                                />
                                                                                                <path
                                                                                                    d="M3 12h13a6 6 0 0 1 6 6v1"
                                                                                                    strokeLinecap="round"
                                                                                                    strokeLinejoin="round"
                                                                                                />
                                                                                            </svg>
                                                                                        </span>

                                                                                        <span
                                                                                            ref={node => {
                                                                                                let clickedId = null;
                                                                                                if (item?.id) clickedId = `item-${item.id}`;
                                                                                                else if (selectedMail?.id) clickedId = `selectedMail-${selectedMail.id}`;
                                                                                                else if (childTaskData?.Email?.id) clickedId = `child-${childTaskData.Email.id}`;
                                                                                                else if (getemailbyid?.id) clickedId = `email-${getemailbyid.id}`;
                                                                                                if (clickedId) dropdownRefs.current[clickedId] = node;
                                                                                            }}
                                                                                            className="mail-reading-action-btn relative more-options-container"
                                                                                            title="More options"
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();

                                                                                                let clickedId = null;

                                                                                                if (item?.id) clickedId = `item-${item.id}`;
                                                                                                else if (selectedMail?.id) clickedId = `selectedMail-${selectedMail.id}`;
                                                                                                else if (childTaskData?.Email?.id) clickedId = `child-${childTaskData.Email.id}`;
                                                                                                else if (getemailbyid?.id) clickedId = `email-${getemailbyid.id}`;

                                                                                                if (openModalId === clickedId) {
                                                                                                    setOpenModalId(null);
                                                                                                } else {
                                                                                                    setOpenModalId(clickedId);
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#444" strokeWidth="1.5" viewBox="0 0 24 24">
                                                                                                <circle cx="12" cy="5" r="1.5" />
                                                                                                <circle cx="12" cy="12" r="1.5" />
                                                                                                <circle cx="12" cy="19" r="1.5" />
                                                                                            </svg>

                                                                                            {(openModalId === `item-${item?.id}` ||
                                                                                                openModalId === `selectedMail-${selectedMail?.id}` ||
                                                                                                openModalId === `child-${childTaskData?.Email?.id}` ||
                                                                                                openModalId === `email-${getemailbyid?.id}`) && (
                                                                                                    <div className="mail-reading-more-menu">
                                                                                                        <div>

                                                                                                            <button
                                                                                                                type="button"
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handlereply('visible', idx, item);
                                                                                                                    setOpenModalId(null);

                                                                                                                }}
                                                                                                            >
                                                                                                                Reply
                                                                                                            </button>
                                                                                                            {shouldShowReplyAll ? (
                                                                                                                <button
                                                                                                                    type="button"
                                                                                                                    onClick={(e) => {
                                                                                                                        e.stopPropagation();
                                                                                                                        setIsvisible(true)
                                                                                                                        handleReplyAll(item, 'visible', idx);
                                                                                                                        setOpenModalId(null);

                                                                                                                    }}
                                                                                                                >
                                                                                                                    Reply all
                                                                                                                </button>
                                                                                                            ) : (null)}
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleForward('visible', idx, item);
                                                                                                                    setOpenModalId(null);
                                                                                                                }}
                                                                                                            >
                                                                                                                Forward
                                                                                                            </button>

                                                                                                            <button
                                                                                                                type="button"
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    let clickedId = null;
                                                                                                                    if (item?.id) clickedId = `item-${item.id}`;
                                                                                                                    else if (selectedMail?.id) clickedId = `selectedMail-${selectedMail.id}`;
                                                                                                                    else if (childTaskData?.Email?.id) clickedId = `child-${childTaskData.Email.id}`;
                                                                                                                    else if (getemailbyid?.id) clickedId = `email-${getemailbyid.id}`;
                                                                                                                    const anchorNode = clickedId ? dropdownRefs.current[clickedId] : null;
                                                                                                                    setSelectedSubEmailID(item?.id);
                                                                                                                    setSubEmailLabelAnchorEl(anchorNode);
                                                                                                                    setOpenModalId(null);
                                                                                                                }}
                                                                                                            >
                                                                                                                <LabelIcon fontSize="small" sx={{ marginRight: 1 }} />
                                                                                                                Label
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                        </span>

                                                                                    </div>

                                                                                </div>

                                                                                <div className="mail-reading-body-wrap">
                                                                                <SandboxedEmail
                                                                                    className="mail-reading-body"
                                                                                    html={formatMailBodyNonDestructive(main)}
                                                                                />

                                                                                {count >= 1 &&
                                                                                    expandedThreadIndex !== idx && (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="mail-reading-expand-btn"
                                                                                            onClick={() =>
                                                                                                setExpandedThreadIndex(
                                                                                                    idx,
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <span>...</span>
                                                                                        </button>
                                                                                    )}
                                                                                {expandedThreadIndex === idx &&
                                                                                    count >= 1 && (
                                                                                        <>
                                                                                            <SandboxedEmail
                                                                                                className="mail-reading-body gmail-thread"
                                                                                                html={formatMailBodyNonDestructive(rest)}
                                                                                            />
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={() =>
                                                                                                        setExpandedThreadIndex(
                                                                                                            null,
                                                                                                        )
                                                                                                    }
                                                                                                    className="mail-reading-collapse-btn"
                                                                                                >
                                                                                                    Show less
                                                                                                </button>
                                                                                        </>
                                                                                    )}
                                                                                </div>

                                                                                {!visibleReplyIndexes.has(idx) ?
                                                                                    null : (

                                                                                        <ReplyDropdown
                                                                                            draftidx={idx}
                                                                                            draftBody={draftBody}
                                                                                            emailValue={emailValue}
                                                                                            cc={cc}
                                                                                            bcc={bcc}
                                                                                            showCc={showCc}
                                                                                            showBcc={showBcc}
                                                                                            setEmailValue={setEmailValue}
                                                                                            setCc={setCc}
                                                                                            setBcc={setBcc}
                                                                                            setShowCc={setShowCc}
                                                                                            setShowBcc={setShowBcc}
                                                                                            handleEmailChange={handleEmailChange}
                                                                                            handleCcChange={handleCcChange}
                                                                                            handleBccChange={handleBccChange}
                                                                                            replyDropdown={replyDropdown2}
                                                                                            setReplyDropdown={setReplyDropdown2}
                                                                                            isForward={isForward}
                                                                                            isReply={isReply}
                                                                                            templateselect={templateselect}
                                                                                            setTemplateselect={setTemplateselect}
                                                                                            allTemp={allTemp}
                                                                                            template={template}
                                                                                            setTemplate={setTemplate}
                                                                                            textAreaValue={textAreaValue}
                                                                                            setTextAreaValue={setTextAreaValue}
                                                                                            visibleReplies={visibleReplies}
                                                                                            selectedMail={selectedMail}
                                                                                            isReplyloading={isReplyloading}
                                                                                            createTask={createTask}
                                                                                            handleFileChange={handleFileChange}
                                                                                            uploadedFiles={uploadedFiles}
                                                                                            handleRemoveFile={handleRemoveFile}
                                                                                            handleDelete={() => handleDelete('visible', idx)}
                                                                                            setShowBccCc={setShowBccCc}
                                                                                            getemailbyid={getemailbyid}
                                                                                            childTaskData={childTaskData}
                                                                                            mode='visible'
                                                                                            idx={item?.id}
                                                                                            saveDrafts={saveDrafts}
                                                                                            submitData={submitData}
                                                                                            setSubmitData={setSubmitData}
                                                                                            labelname={replyLabelname}
                                                                                            setLabelAnchorEl={setReplyLabelAnchorEl}
                                                                                        />

                                                                                    )}
                                                                            </div>

                                                                            {item.attachmentPaths &&
                                                                                item.attachmentPaths.length > 0 && (
                                                                                    <div
                                                                                        className="gmail-attachment-list"
                                                                                        style={{ padding: '0 4.25rem' }}
                                                                                    >
                                                                                        {item.attachmentPaths.map(
                                                                                            (file, attIdx) => {
                                                                                                const fileUrl = `${process.env
                                                                                                    .REACT_APP_IMAGE_URL ||
                                                                                                    ''
                                                                                                    }/${file}`;
                                                                                                return (
                                                                                                    <div
                                                                                                        className="gmail-attachment-card"
                                                                                                        key={attIdx}
                                                                                                    >
                                                                                                        {/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
                                                                                                            file,
                                                                                                        ) ? (
                                                                                                            <a
                                                                                                                href={
                                                                                                                    fileUrl
                                                                                                                }
                                                                                                                target="_blank"
                                                                                                                rel="noopener noreferrer"
                                                                                                            >
                                                                                                                <img
                                                                                                                    src={
                                                                                                                        fileUrl
                                                                                                                    }
                                                                                                                    alt={
                                                                                                                        file
                                                                                                                    }
                                                                                                                    style={{
                                                                                                                        width: 120,
                                                                                                                        height: 120,
                                                                                                                        objectFit:
                                                                                                                            'cover',
                                                                                                                        borderRadius: 8,
                                                                                                                        border: '1px solid #eee',
                                                                                                                    }}
                                                                                                                />
                                                                                                            </a>
                                                                                                        ) : (

                                                                                                            <div>
                                                                                                                <div className="gmail-attachment-filename-url">
                                                                                                                    {(() => {
                                                                                                                        const ext =
                                                                                                                            file
                                                                                                                                .split(
                                                                                                                                    '.',
                                                                                                                                )
                                                                                                                                .pop();
                                                                                                                        const name =
                                                                                                                            file.slice(
                                                                                                                                0,
                                                                                                                                -(
                                                                                                                                    ext.length +
                                                                                                                                    1
                                                                                                                                ),
                                                                                                                            );
                                                                                                                        return name.length >
                                                                                                                            10
                                                                                                                            ? `${name.slice(
                                                                                                                                0,
                                                                                                                                10,
                                                                                                                            )}... .${ext}`
                                                                                                                            : file;
                                                                                                                    })()}
                                                                                                                </div>
                                                                                                                <div>
                                                                                                                    <div className="gmail-attachment-pdficon gap-2">
                                                                                                                        <div>
                                                                                                                            <svg
                                                                                                                                width="32"
                                                                                                                                height="32"
                                                                                                                                viewBox="0 0 24 24"
                                                                                                                                fill="none"
                                                                                                                            >
                                                                                                                                <rect
                                                                                                                                    width="24"
                                                                                                                                    height="24"
                                                                                                                                    rx="4"
                                                                                                                                    fill="#F44336"
                                                                                                                                />
                                                                                                                                <text
                                                                                                                                    x="6"
                                                                                                                                    y="17"
                                                                                                                                    fill="#fff"
                                                                                                                                    fontSize="10"
                                                                                                                                    fontWeight="bold"
                                                                                                                                >
                                                                                                                                    {file
                                                                                                                                        .split(
                                                                                                                                            '.',
                                                                                                                                        )
                                                                                                                                        .pop()
                                                                                                                                        .toUpperCase()}
                                                                                                                                </text>
                                                                                                                            </svg>
                                                                                                                        </div>
                                                                                                                        <div>
                                                                                                                            <span className="gmail-attachment-filename">
                                                                                                                                {' '}
                                                                                                                                {(() => {
                                                                                                                                    const ext =
                                                                                                                                        file
                                                                                                                                            .split(
                                                                                                                                                '.',
                                                                                                                                            )
                                                                                                                                            .pop();
                                                                                                                                    const name =
                                                                                                                                        file.slice(
                                                                                                                                            0,
                                                                                                                                            -(
                                                                                                                                                ext.length +
                                                                                                                                                1
                                                                                                                                            ),
                                                                                                                                        );
                                                                                                                                    return name.length >
                                                                                                                                        10
                                                                                                                                        ? `${name.slice(
                                                                                                                                            0,
                                                                                                                                            10,
                                                                                                                                        )}... .${ext}`
                                                                                                                                        : file;
                                                                                                                                })()}
                                                                                                                            </span>
                                                                                                                        </div>
                                                                                                                        <div className="gmail-attachment-actions" style={{ display: 'flex', gap: '8px' }}>
                                                                                                                            <a
                                                                                                                                href={fileUrl}
                                                                                                                                target="_blank"
                                                                                                                                rel="noopener noreferrer"
                                                                                                                                className="gmail-attachment-action-btn"
                                                                                                                                title="Preview"
                                                                                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                                                                                            >
                                                                                                                                <svg
                                                                                                                                    width="20"
                                                                                                                                    height="20"
                                                                                                                                    fill="#555"
                                                                                                                                    viewBox="0 0 24 24"
                                                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                                                >
                                                                                                                                    <path d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12a5 5 0 110-10 5 5 0 010 10z" />
                                                                                                                                    <circle cx="12" cy="12" r="2.5" />
                                                                                                                                </svg>
                                                                                                                            </a>
                                                                                                                            <a
                                                                                                                                href={
                                                                                                                                    fileUrl
                                                                                                                                }
                                                                                                                                download={
                                                                                                                                    file
                                                                                                                                }
                                                                                                                                target="_blank"
                                                                                                                                rel="noopener noreferrer"
                                                                                                                                className="gmail-attachment-action-btn"
                                                                                                                                title="Download"
                                                                                                                            >
                                                                                                                                <svg
                                                                                                                                    width="20"
                                                                                                                                    height="20"
                                                                                                                                    fill="#555"
                                                                                                                                    viewBox="0 0 16 16"
                                                                                                                                >
                                                                                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5V13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.6a.5.5 0 0 1 1 0V13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.6a.5.5 0 0 1 .5-.5z" />
                                                                                                                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                                                                                                </svg>
                                                                                                                            </a>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                );
                                                                                            },
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    );
                                                                })}
                                                        </div>
                                                    </div>
                                                    {!replyDropdown3 && !isReplyloading && (
                                                        <div
                                                            style={{ marginBottom: '6.25rem' }}
                                                            className="flex flex-col md:flex-row gap-1 xl:gap-2 items-start justify-start mt-[25px]"
                                                        >


                                                            <div
                                                                className="flex flex-row items-start
                             gap-3 md:pl-[2.5vw] mt-4"
                                                            >

                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        if (isInboxVisible && !selectedMail?.boardId) {
                                                                            setShowisMailVisible(true);
                                                                        } else {
                                                                            handleClick(); handlereply('-', null, lastReplyBody || selectedMail), setLabelForDraft({ label: "-" })
                                                                        }
                                                                    }}
                                                                    className="mail-action-btn mail-action-btn--reply"
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="20"
                                                                        height="20"
                                                                        fill="none"
                                                                        strokeWidth="1.8"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            d="M10 19l-7-7 7-7"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M3 12h13a6 6 0 0 1 6 6v1"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                    Reply
                                                                </button>

                                                                {shouldShowReplyAll ? (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            if (isInboxVisible && !selectedMail?.boardId) {
                                                                                setShowisMailVisible(true);
                                                                            } else {
                                                                                handleReplyAll(lastReplyBody || selectedMail, '-'), setLabelForDraft({ label: "-" })
                                                                            }
                                                                        }}
                                                                        className="mail-action-btn mail-action-btn--reply-all"
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="20"
                                                                            height="20"
                                                                            fill="none"
                                                                            strokeWidth="1.8"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                d="M10 19l-7-7 7-7"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M3 12h13a6 6 0 0 1 6 6v1"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                        </svg>
                                                                        Reply all
                                                                    </button>
                                                                ) : null}

                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        if (isInboxVisible && !selectedMail?.boardId) {
                                                                            setShowisMailVisible(true)
                                                                        } else {
                                                                            handleForward('-', null, lastReplyBody || selectedMail), setLabelForDraft({ label: "-" })
                                                                        }
                                                                    }}
                                                                    className="mail-action-btn mail-action-btn--forward"
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" strokeWidth="1.5" viewBox="0 0 24 24">
                                                                        <path d="M14 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M21 12H8a6 6 0 0 0-6 6v1" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                    Forward
                                                                </button>

                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div style={{ textAlign: 'center' }}>
                                                <span>Email Not Found</span>
                                            </div>
                                        </>
                                    )}

                                    {!replyDropdown3 && !isReplyloading ?
                                        null : (
                                            <ReplyDropdown
                                                draftBody={draftBody}
                                                emailValue={emailValue}
                                                cc={cc}
                                                bcc={bcc}
                                                showCc={showCc}
                                                showBcc={showBcc}
                                                setEmailValue={setEmailValue}
                                                setCc={setCc}
                                                setBcc={setBcc}
                                                setShowCc={setShowCc}
                                                setShowBcc={setShowBcc}
                                                handleEmailChange={handleEmailChange}
                                                handleCcChange={handleCcChange}
                                                handleBccChange={handleBccChange}
                                                replyDropdown={replyDropdown3}
                                                setReplyDropdown={setReplyDropdown3}
                                                isForward={isForward}
                                                isReply={isReply}
                                                templateselect={templateselect}
                                                setTemplateselect={setTemplateselect}
                                                allTemp={allTemp}
                                                template={template}
                                                setTemplate={setTemplate}
                                                textAreaValue={textAreaValue}
                                                setTextAreaValue={setTextAreaValue}
                                                visibleReplies={visibleReplies}
                                                selectedMail={selectedMail}
                                                isReplyloading={isReplyloading}
                                                createTask={createTask}
                                                handleFileChange={handleFileChange}
                                                uploadedFiles={uploadedFiles}
                                                handleRemoveFile={handleRemoveFile}
                                                handleDelete={() => handleDelete('-')}
                                                setShowBccCc={setShowBccCc}
                                                getemailbyid={getemailbyid}
                                                childTaskData={childTaskData}
                                                mode='-'
                                                saveDrafts={saveDrafts}
                                                submitData={submitData}
                                                setSubmitData={setSubmitData}
                                                labelname={replyLabelname}
                                                setLabelAnchorEl={setReplyLabelAnchorEl}
                                            />
                                        )}
                                    {showisMailVisible && (
                                        <NoReplyMailModal showisMailVisible={showisMailVisible} setShowisMailVisible={setShowisMailVisible} />
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>




    );
};

export default MailInbox;
